import React, { useMemo, memo } from "react";
import "./LogoCarousel.css";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { AcademiesLogo } from "../../../../helpers/Images";

const LogoCarouse = memo(() => {
  // Create array of logo images - using useMemo to prevent recreation on every render
  const logoImages = useMemo(() => {
    return Object.values(AcademiesLogo).map((logo, index) => ({
      id: index + 1,
      src: logo,
    }));
  }, []);

  return (
    <Box
      className="logo-carousel-section"
      sx={{
        width: "100%",
        padding: {
          xs: "50px 20px 50px",
          sm: "50px 60px 50px",
          lg: "70px 120px 70px",
        },
        backgroundColor: "secondary.main",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Typography
          variant="h2"
          className="logo-carousel-title"
          sx={{
            textAlign: "center",
            fontSize: { xs: "32px", sm: "42px", md: "48px" },
            fontWeight: "700",
            color: "primary.darker",
            marginBottom: "12px",
            letterSpacing: "-0.5px",
          }}
        >
          Success Partners
        </Typography>
        <Box
          sx={{
            height: "4px",
            width: { xs: "120px", md: "180px" },
            background:
              "linear-gradient(90deg, transparent, #830d0b, transparent)",
            margin: "0 auto 30px auto",
            borderRadius: "2px",
            // boxShadow: "0 2px 8px rgba(131, 13, 11, 0.3)",
          }}
        />
        <Box className="LogoContainer">
          <Box className="logo-track">
            {/* First set of logos */}
            {logoImages.map((logo) => (
              <Box
                key={`logo-1-${logo.id}`}
                className="logo-item"
                component="img"
                src={logo.src}
                alt={`Partner logo ${logo.id}`}
                loading="lazy"
                sx={{
                  height: { xs: "80px", sm: "100px" },
                  width: "auto",
                  objectFit: "contain",
                  margin: "0 30px",
                  transition: "filter 0.3s ease",
                  "&:hover": {
                    filter: "grayscale(0%) opacity(1)",
                  },
                }}
              />
            ))}
            {/* Duplicate set for seamless loop */}
            {logoImages.map((logo) => (
              <Box
                key={`logo-2-${logo.id}`}
                className="logo-item"
                component="img"
                src={logo.src}
                alt={`Partner logo ${logo.id}`}
                loading="lazy"
                sx={{
                  height: { xs: "80px", sm: "100px" },
                  width: "auto",
                  objectFit: "contain",
                  margin: "0 30px",
                  transition: "filter 0.3s ease",
                  "&:hover": {
                    filter: "grayscale(0%) opacity(1)",
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
});

LogoCarouse.displayName = "LogoCarousel";

export default LogoCarouse;
